import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleGuida() {
  return <ArticleLayout article={articleContents['itaobuy-spreadsheet-guida']} />;
}